var map = {
	"./af.json": 3069,
	"./am.json": 9860,
	"./ar.json": 6726,
	"./az.json": 2795,
	"./be.json": 2654,
	"./bg.json": 4901,
	"./bn.json": 8169,
	"./bs.json": 8430,
	"./ca.json": 3886,
	"./ceb.json": 4808,
	"./co.json": 9919,
	"./cs.json": 9744,
	"./cy.json": 8758,
	"./da.json": 5638,
	"./de.json": 9929,
	"./el.json": 7498,
	"./en.json": 790,
	"./eo.json": 7798,
	"./es.json": 8563,
	"./et.json": 8034,
	"./eu.json": 6485,
	"./fa.json": 9603,
	"./fi.json": 2276,
	"./fil.json": 8919,
	"./fr.json": 844,
	"./fy.json": 6191,
	"./ga.json": 2418,
	"./gd.json": 5420,
	"./gl.json": 1077,
	"./gu.json": 37,
	"./ha.json": 3656,
	"./haw.json": 6732,
	"./he.json": 8818,
	"./hi.json": 9493,
	"./hmn.json": 6742,
	"./hr.json": 4253,
	"./ht.json": 6578,
	"./hu.json": 4626,
	"./hy.json": 6283,
	"./id.json": 8446,
	"./ig.json": 6764,
	"./is.json": 2188,
	"./it.json": 504,
	"./iw.json": 3892,
	"./ja.json": 8566,
	"./jw.json": 2595,
	"./ka.json": 1574,
	"./kk.json": 4887,
	"./km.json": 655,
	"./kn.json": 3098,
	"./ko.json": 7697,
	"./ku.json": 6476,
	"./ky.json": 5841,
	"./la.json": 53,
	"./lb.json": 3266,
	"./lo.json": 6583,
	"./lt.json": 1560,
	"./lv.json": 9071,
	"./mg.json": 5607,
	"./mi.json": 9220,
	"./mk.json": 7483,
	"./ml.json": 8729,
	"./mn.json": 7100,
	"./mr.json": 4069,
	"./ms.json": 9192,
	"./mt.json": 8871,
	"./my.json": 6091,
	"./ne.json": 2998,
	"./nl.json": 3055,
	"./no.json": 438,
	"./ny.json": 9646,
	"./pa.json": 960,
	"./pl.json": 5143,
	"./ps.json": 4064,
	"./pt.json": 9898,
	"./ro.json": 4691,
	"./ru.json": 9672,
	"./sd.json": 2559,
	"./si.json": 1578,
	"./sk.json": 1941,
	"./sl.json": 5329,
	"./sm.json": 4545,
	"./sn.json": 228,
	"./so.json": 8567,
	"./sq.json": 7263,
	"./sr.json": 7931,
	"./st.json": 8951,
	"./su.json": 6536,
	"./sv.json": 3244,
	"./sw.json": 9689,
	"./ta.json": 2446,
	"./te.json": 472,
	"./tg.json": 5958,
	"./th.json": 2009,
	"./ti.json": 7495,
	"./tl.json": 6831,
	"./tr.json": 2021,
	"./uk.json": 1754,
	"./ur.json": 237,
	"./uz.json": 7534,
	"./vi.json": 245,
	"./xh.json": 7810,
	"./yi.json": 8369,
	"./yo.json": 8444,
	"./zh-cn.json": 4813,
	"./zh-tw.json": 7742,
	"./zu.json": 6062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3251;